/**
 * Coin logos — CoinGecko CDN (matches backend markets/coin_icons.py) + fallbacks.
 */
const COIN_IMAGE_BY_SYMBOL = {
  BTC: "https://coin-images.coingecko.com/coins/images/1/small/bitcoin.png",
  ETH: "https://coin-images.coingecko.com/coins/images/279/small/ethereum.png",
  BNB: "https://coin-images.coingecko.com/coins/images/825/small/bnb-icon2_2x.png",
  XRP: "https://coin-images.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png",
  SOL: "https://coin-images.coingecko.com/coins/images/4128/small/solana.png",
  TRX: "https://coin-images.coingecko.com/coins/images/1094/small/photo_2026-04-13_09-59-16.png",
  DOGE: "https://coin-images.coingecko.com/coins/images/5/small/dogecoin.png",
  ADA: "https://coin-images.coingecko.com/coins/images/975/small/cardano.png",
  BCH: "https://coin-images.coingecko.com/coins/images/780/small/bitcoin-cash-circle.png",
  LINK: "https://coin-images.coingecko.com/coins/images/877/small/Chainlink_Logo_500.png",
  LTC: "https://coin-images.coingecko.com/coins/images/2/small/litecoin.png",
  AVAX: "https://coin-images.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png",
  HBAR: "https://coin-images.coingecko.com/coins/images/3688/small/hbar.png",
  NEAR: "https://coin-images.coingecko.com/coins/images/10365/small/near.jpg",
  UNI: "https://coin-images.coingecko.com/coins/images/12504/small/uniswap-logo.png",
  DOT: "https://coin-images.coingecko.com/coins/images/12171/small/polkadot.jpg",
  ICP: "https://coin-images.coingecko.com/coins/images/14495/small/Internet_Computer_logo.png",
  ETC: "https://coin-images.coingecko.com/coins/images/453/small/ethereum-classic-logo.png",
  AAVE: "https://coin-images.coingecko.com/coins/images/12645/small/aave-token-round.png",
  ATOM: "https://coin-images.coingecko.com/coins/images/1481/small/cosmos_hub.png",
  ALGO: "https://coin-images.coingecko.com/coins/images/4380/small/algorand-logo.png",
  APT: "https://coin-images.coingecko.com/coins/images/26455/small/Aptos-Network-Symbol-Black-RGB-1x.png",
  FIL: "https://coin-images.coingecko.com/coins/images/12817/small/filecoin.png",
  ARB: "https://coin-images.coingecko.com/coins/images/16547/small/arb.jpg",
  VET: "https://coin-images.coingecko.com/coins/images/1167/small/VET.png",
  OP: "https://coin-images.coingecko.com/coins/images/25244/small/Optimism.png",
  SAND: "https://coin-images.coingecko.com/coins/images/12129/small/sandbox_logo.jpg",
  MANA: "https://coin-images.coingecko.com/coins/images/878/small/decentraland-mana.png",
  MATIC: "https://coin-images.coingecko.com/coins/images/4713/small/polygon.png",
  USDT: "https://coin-images.coingecko.com/coins/images/325/small/Tether.png",
  USDC: "https://coin-images.coingecko.com/coins/images/6319/small/usdc.png",
};

function normalizeCgUrl(url) {
  if (!url || typeof url !== "string") return "";
  const u = url.split("?")[0];
  return u.replace("/large/", "/small/").replace("/thumb/", "/small/");
}

/** @param {string} symbol @param {string} [apiImage] */
export function getCoinIconCandidates(symbol, apiImage) {
  const sym = String(symbol || "").toUpperCase();
  const lower = sym.toLowerCase();
  const out = [];

  const fromApi = normalizeCgUrl(apiImage);
  if (fromApi.startsWith("http")) out.push(fromApi);
  if (COIN_IMAGE_BY_SYMBOL[sym]) out.push(COIN_IMAGE_BY_SYMBOL[sym]);
  if (sym === "POL" && COIN_IMAGE_BY_SYMBOL.MATIC) out.push(COIN_IMAGE_BY_SYMBOL.MATIC);
  out.push(`https://assets.coincap.io/assets/icons/${lower}@2x.png`);
  out.push(`https://cdn.jsdelivr.net/gh/spothq/cryptocurrency-icons@master/128/color/${lower}.png`);

  return [...new Set(out.filter(Boolean))];
}

/** @param {string} symbol @param {string} [apiImage] */
export function getCoinIconUrl(symbol, apiImage) {
  const candidates = getCoinIconCandidates(symbol, apiImage);
  return candidates[0] || "";
}
